import { render, staticRenderFns } from "./EditVideo.vue?vue&type=template&id=51524467&"
import script from "./EditVideo.vue?vue&type=script&lang=js&"
export * from "./EditVideo.vue?vue&type=script&lang=js&"
import style0 from "./EditVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports